// @flow
/* -----------------Globals--------------- */
import React from 'react';

/* -----------------UI--------------- */
import {
  Paper,
  Box,
  Grid,
} from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import useMediaQuery from '@material-ui/core/useMediaQuery';

/* -----------------Props--------------- */
type Props = {
  showProgress?: boolean,
  numFacts?: number,
};

/* -----------------Component--------------- */
const TermCardSkeleton = (props: Props) => {
  const {
    showProgress = true,
    numFacts = 1,
  } = props;

  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));

  const showProgressCircle = () => {
    if (showProgress) {
      return isMobile;
    }
    return showProgress;
  };

  return (
    <Paper
      elevation={0}
      style={{
        marginBottom: 8,
        display: 'flex',
        padding: 16,
        paddingTop: isMobile ? 20 : 24,
        paddingBottom: 24,
        width: '100%',
        minHeight: isMobile ? 110 : 88,
      }}
    >
      {showProgressCircle() && !isMobile
        ? (
          <Box pr={2}>
            <Skeleton variant="circle" width={48} height={48} />
          </Box>
        ) : null }
      <Grid container spacing={1}>
        <Grid
          item
          container
          display="flex"
          alignItems="center"
          xs={12}
          sm={12}
          md={6}
        >
          <Skeleton variant="rect" width="80%" animation="wave" />
        </Grid>
        <Grid
          item
          container
          display="flex"
          direction="column"
          spacing={1}
          justifyContent="center"
          xs={12}
          sm={12}
          md={6}
          style={{ paddingLeft: 8, marginTop: isMobile ? 10 : 0 }}
        >
          {[...Array(numFacts).keys()].map(item => (
            <Grid
              item
              key={item}
            >
              <Skeleton
                variant="rect"
                width="80%"
                height={14}
                animation="wave"
              />
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Paper>
  );
};

export default TermCardSkeleton;
